const removeAction = (uniqueKey) => ({
    type: 'APP_HISTORY_PANEL_REMOVE',
    payload: uniqueKey,
});

export {
    removeAction,
}
